import { useRef } from "react";
import { Card, Progress } from "flowbite-react";
import { FaChevronDown, FaStore, FaTrophy } from "react-icons/fa";
import { launchCelebrationConfetti } from "../../../utils/confetti";

const ProgressoCadastro = ({
  metasCadastroLoja,
  progressoCadastro,
  metasCompletadas,
  alternarCard,
  cardsExpandidos,
}) => {
  const todasMetasBatidas = Object.values(progressoCadastro).every(
    (progresso) => progresso === 100
  );

  const confettiRef = useRef(null);

  const dispararConfetes = () => {
    launchCelebrationConfetti();
  };

  return (
    <Card
      className="shadow-md text-center rounded-xl bg-white border border-gray-300 cursor-pointer relative"
      onClick={() => alternarCard("cadastroLoja")}
    >
      <FaChevronDown className="absolute top-3 right-3 text-gray-400" />
      <FaStore className="text-4xl text-orange-500 mx-auto mb-2" />
      <h3 className="text-lg font-semibold text-gray-800">
        Completar Cadastro da Loja
      </h3>

      {todasMetasBatidas ? (
        // Exibe um troféu gigante e dispara confetes ao clicar
        <div
          className="flex flex-col items-center justify-center my-4 cursor-pointer"
          onClick={dispararConfetes}
          ref={confettiRef}
        >
          <FaTrophy className="text-6xl text-yellow-500 animate-bounce" />
        </div>
      ) : (
        // Caso contrário, exibe as barras de progresso das metas pendentes
        <>
          {Object.entries(metasCadastroLoja).map(([meta, descricao]) =>
            progressoCadastro[meta] < 100 ? (
              <div key={meta} className="mb-2">
                <p className="text-gray-600">{descricao}</p>
                <Progress progress={progressoCadastro[meta]} color="yellow" />
              </div>
            ) : null
          )}
        </>
      )}

      {/* Exibe conquistas apenas se houver metas completadas */}
      {cardsExpandidos.cadastroLoja && metasCompletadas.length > 0 && (
        <div className="mt-4">
          <h4 className="text-md font-semibold text-gray-700">Conquistas</h4>
          {metasCompletadas.map((trofeu, index) => (
            <div
              key={index}
              className="flex justify-between items-center text-gray-600"
            >
              <span>{trofeu.titulo}</span>
              <FaTrophy className="text-yellow-500 text-lg" />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ProgressoCadastro;
